import Loandetailsclosedview from "../../../jsx/components/Dashboard/LoanDetails/loandetailsclosedview";

const LoanDetailsClosedViewWrapper = () => {
  return <Loandetailsclosedview />;
};

export default constore(LoanDetailsClosedViewWrapper);
